import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Calculator from "@/components/Calculator";
import HowItWorks from "@/components/HowItWorks";
import FoundingPass from "@/components/FoundingPass";
import ShiftsBoard from "@/components/ShiftsBoard";
import VenuePost from "@/components/VenuePost";
import Trust from "@/components/Trust";
import Faq from "@/components/Faq";
import Waitlist from "@/components/Waitlist";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import CityPage from "@/pages/CityPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import PaymentResult from "@/pages/PaymentResult";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Calculator />
        <HowItWorks />
        <ShiftsBoard />
        <VenuePost />
        <FoundingPass />
        <Trust />
        <Faq />
        <Waitlist />
      </main>
      <Footer />
      <ChatWidget />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/cities/:city" element={<CityPage />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  const appShell = (
    <div className="App bg-[#07090e] text-slate-50 antialiased">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-right" toastOptions={{
        style: { background: "#0f141c", border: "1px solid rgba(245,158,11,0.35)", color: "#f8fafc" },
      }} />
    </div>
  );
  // Custom branded Google sign-in only when a client ID is configured;
  // otherwise the managed Google flow button remains active.
  return GOOGLE_CLIENT_ID ? (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{appShell}</GoogleOAuthProvider>
  ) : appShell;
}

export default App;
